/* eslint-disable react/jsx-pascal-case */
import React from 'react';
import CIP_Calculator_Form from './CIP_Calculator';

const CIPCalculator = () => {
  return (
    <div>
      <CIP_Calculator_Form />
    </div>
  );
};
export default CIPCalculator;